import SectionControlView from "../../views/mobile/SectionControlView";
import MobileSectionModel from "../../models/mobile/MobileSectionModel";
import $ from "jquery";
import mobileConstants from '../../mobile/commons/MobileFormsConstants';
import BaseVisualControlFactory from "../BaseVisualControlFactory";

class ControlSectionFactory extends BaseVisualControlFactory {

    createView(section, columnId) {

        const attributes = this.createChildAttributes( mobileConstants.SECTION_FACTORY_KEY);
        attributes.silent = true;

        // attributes for section
        attributes.backgroundColor = '~sectionBgColor';
        attributes.backgroundImage = '~sectionBgImage';
        attributes.backgroundImageAssetId = '~sectionBgImage';
        attributes.backgroundImageTag = '';
        attributes.backgroundImageStyle = '';
        attributes.alignBackgroundImageStyle = '';
        attributes.transparentBackground = '~sectionBgTransparent';
        attributes.borderSize = '~sectionBorderSize';
        attributes.borderStyle = '~sectionBorderStyle';
        attributes.borderColor = '~sectionBorderColor';
        attributes.cornerRadius= '~sectionCornerRadius';
        attributes.minWidth = '100%';
        attributes.minHeight = 45;
        attributes.marginTop = 10;
        attributes.marginBottom = 10;
        attributes.contentHeight = 0;

        // attributes for section header
        attributes.headerBackgroundColor = '~sectionHeaderBgColor';
        attributes.headerColor ='~sectionTextColor';
        attributes.headerFontFamily = '~sectionFont';
        attributes.headerFontSize = '~sectionFont';
        attributes.headerTextWeight = '~sectionFont';
        attributes.headerTextStyle  = '~sectionFont';
        attributes.titleFontFamily = '~sectionFont';
        attributes.titleFontSize = '~sectionFont';
        attributes.titleTextWeight = '~sectionFont';
        attributes.titleTextStyle  = '~sectionFont';
        attributes.headerHeight = '25';
        attributes.headerBorderSize = '~sectionBorderSize';
        attributes.headerBorderStyle = '~sectionBorderStyle';
        attributes.headerBorderColor = '~sectionBorderColor';

        attributes.hasTitle = 'true';
        attributes.titleText = section.name;
        attributes.titleAlign ='~sectionHeaderAlignment';
        attributes.titleHeight = '20';

        attributes.top = '';
        attributes.left = '';
        attributes.name = section.name;

        attributes.childList = [];

        return new SectionControlView (
            {
                model: new MobileSectionModel( attributes ),
                el: $(mobileConstants.COLUMN_ONE_CONTENT_ID),
                factoryKey: mobileConstants.SECTION_FACTORY_KEY,
                id: section.id
            } );
    }
}

const controlSectionFactory = new ControlSectionFactory();
export default controlSectionFactory;